"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureEncoding = exports.SignatureMethod = exports.SignatureStatus = void 0;
var SignatureStatus;
(function (SignatureStatus) {
    /// La firma es válida
    SignatureStatus[SignatureStatus["Valid"] = 0] = "Valid";
    /// Firma inválida
    SignatureStatus[SignatureStatus["Invalid"] = 1] = "Invalid";
    /// El certificado estaba expirado cuando 
    SignatureStatus[SignatureStatus["ExpiredCertificate"] = 2] = "ExpiredCertificate";
    /// El certificado no era válido cuando se realizó la firma
    SignatureStatus[SignatureStatus["NotYetValidCertificate"] = 3] = "NotYetValidCertificate";
    /// La firma está corruptamut 
    SignatureStatus[SignatureStatus["CorruptedSignature"] = 4] = "CorruptedSignature";
    /// El certificado estaba revocado cuando se generó la firma
    SignatureStatus[SignatureStatus["RevokedCertificate"] = 5] = "RevokedCertificate";
    /// Error genérico
    SignatureStatus[SignatureStatus["CouldNotVerify"] = 6] = "CouldNotVerify";
    /// Custom data field is already contained in verification json
    SignatureStatus[SignatureStatus["CustomDataContained"] = 7] = "CustomDataContained";
    /// Indicates custom data is provided, but json to be verified is not a dictionary
    SignatureStatus[SignatureStatus["CustomDataAndNotValue"] = 8] = "CustomDataAndNotValue";
})(SignatureStatus = exports.SignatureStatus || (exports.SignatureStatus = {}));
var SignatureMethod;
(function (SignatureMethod) {
    SignatureMethod["SHA256withRSA"] = "Sha256WithRSA";
})(SignatureMethod = exports.SignatureMethod || (exports.SignatureMethod = {}));
var SignatureEncoding;
(function (SignatureEncoding) {
    SignatureEncoding["Hex"] = "hex";
    SignatureEncoding["Base64"] = "base64";
})(SignatureEncoding = exports.SignatureEncoding || (exports.SignatureEncoding = {}));
//# sourceMappingURL=variants.js.map